import React, { Fragment } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { actions as routerActions } from "redux-router5";
import { connect } from "react-redux";

import PageHeader from "../page/page-header";
import LocaleSwitcher from "../i18n/locale-switcher";
import BankIdLoginForm from "../general-info/bankid-login-form";
import * as Routes from "../routing/routes";
import CustomCaptcha from "../general-info/custom-captcha";
import LayoutWithFooter from "../page/layout-with-footer";
import { getLocale } from "../i18n/locale-selectors";
import { getBrand } from "../brand/brand-selectors";

function HomePage({ brand, locale, goTo, intl }) {
  return (
    <LayoutWithFooter className="HomePage" contentClassName="HomePage__Content">
      <PageHeader
        className={"HomePage__Header"}
        logo={brand.image}
        heading1={"root.title"}
        heading2={brand.homeTitleSecond}
      />
      <div className="description">
        <h3
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: "root.desc" })
          }}
        />
      </div>

      <div className="AuthorizationAndLocale">
        <div className="AuthorizationAndLocale__Inner">
          <LocaleSwitcher />
          <div className="Authorization-flows">
            {brand.ssnEnabled && (
              <BankIdLoginForm
                goTo={goTo}
                routeRedireguidance-sdct={Routes.GUIDANCE_SELF_DIAGNOSTICS}
                lang={locale}
              />
            )}
            {brand.ssnEnabled &&
              brand.anonymousEnabled && (
                <div className="AuthorizationAndLocale__Or">
                  <div className="AuthorizationAndLocale__OrLineLeft" />
                  <div className="AuthorizationAndLocale__OrText">
                    <FormattedMessage id="root.auth.or" />
                  </div>
                  <div className="AuthorizationAndLocale__OrLineRight" />
                </div>
              )}
            {brand.anonymousEnabled && (
              <Fragment>
                <CustomCaptcha
                  goTo={goTo}
                  routeRedirect={Routes.GUIDANCE_SELF_DIAGNOSTICS}
                  lang={locale}
                />
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </LayoutWithFooter>
  );
}

const mapState = state => ({
  locale: getLocale(state),
  brand: getBrand(state)
});

const mapDispatch = {
  goTo: routerActions.navigateTo
};

HomePage = injectIntl(
  connect(
    mapState,
    mapDispatch
  )(HomePage)
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/modules/pages/HomePage.js